import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Respuesta } from '../_models/shared/_index';
import { Novedad } from '../_models/rs-news/_index';
import { Router } from '@angular/router';
import { ErrorService } from './error.service';

@Injectable()
export class RsNewsService {
	private createNovedadUrl = environment.rest + '/RsNews/CrearNovedad';
	private modificarNovedadUrl = environment.rest + '/RsNews/ModificarNovedad';
	private getTagsUrl = environment.rest + '/RsNews/GetTags';
	private getTipoInfoNovedadesUrl =
		environment.rest + '/RsNews/GetTipoInfoNovedades';
	private getNovedadByIdUrl = environment.rest + '/RsNews/GetNovedadById';
	private getNovedadesUrl = environment.rest + '/RsNews/GetNovedades';
	private deleteNovedadUrl = environment.rest + '/RsNews/DeleteNovedad';
	private getStatsNovedadUrl = environment.rest + '/RsNews/getStatsNovedad';
	private getPostsByIdsUrl = environment.rest + '/RsNews/getPostsByIds';

	private options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};
	headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	constructor(
		private http: HttpClient,
		private router: Router,
		private errorService: ErrorService
	) {}

	createNovedad(novedad: Novedad): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.createNovedadUrl, { novedad }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> createNovedad`)
				)
			);
	}

	modificarNovedad(novedad: Novedad): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.modificarNovedadUrl, { novedad }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> modificarNovedad`)
				)
			);
	}

	getNovedadById(idNovedad: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getNovedadByIdUrl, { idNovedad }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getNovedadById`)
				)
			);
	}

	getTags(): Observable<Respuesta> {
		return this.http.get<Respuesta>(this.getTagsUrl, this.options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`GET -> getTags`))
		);
	}

	getTipoInfoNovedades(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getTipoInfoNovedadesUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`GET -> getTipoInfoNovedades`
					)
				)
			);
	}

	getNovedades(todos: boolean): Observable<Respuesta> {
		let params = new HttpParams().set('todos', String(todos));
		var options = {
			headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
			withCredentials: true,
			params: params,
		};
		return this.http.get<Respuesta>(this.getNovedadesUrl, options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(
				this.errorService.handleError<Respuesta>(`GET -> getNovedades`)
			)
		);
	}

	deleteNovedad(id: Number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.deleteNovedadUrl, { id }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> deleteNovedad`)
				)
			);
	}

	getStatsNovedad(id: Number): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getStatsNovedadUrl + '/' + id, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`GET -> getStatsNovedad`)
				)
			);
	}

	getPostByIds(ids: Array<Number>): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getPostsByIdsUrl, { ids }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getPostByIds`)
				)
			);
	}

	////////////////////////////////////////////////

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			this.router.navigate(['error-404'], {
				queryParams: {
					codigoError: error.error.Code,
					mensaje: error.error.Message,
				},
			});

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
